import React, { ReactElement } from "react";
import { PanelMenu } from "primereact/panelmenu";
import { Sidebar } from "primereact/sidebar";
import styles from "./SideBar.module.css";
import logo from "../assets/idwal-logo.svg";

import { useTranslation } from "react-i18next";
import { IIdwalSideBar } from "../types/IIdwalSideBar";
import { Spinner } from "../ProgressSpinner/Spinner";
import { IIdwalSideBarItems } from "../types/IIdwalSideBarItems";

/**
 * The main idwal sidebar for navigating between top level pages.
 */
export const IdwalSideBar = (props: IIdwalSideBar): ReactElement => {
    const { t } = useTranslation("common");

    const company_name = t("company.name");

    const idwalMenuItems = [
        {
            label: props.customerPortalLinkText ?? t("sidebar.customerPortal"),
            icon: "pi pi-fw pi-external-link",
            url: props.customerPortalLink
        }
    ];

    const idwalFooterItems = [
        {
            label: t("sidebar.signOut"),
            icon: "pi pi-fw pi-sign-out",
            url: props.logoutLink
        }
    ];

    let sideBarItems: IIdwalSideBarItems[] = [];
    const spinner = (
        <div className="mt-3">
            <Spinner width={40} height={40} />
        </div>
    );

    if (props.sideBarItems) {
        sideBarItems = props.sideBarItems;
    }

    return (
        <Sidebar
            data-testid="idwal-sidebar"
            visible={props.visible}
            position="right"
            onHide={props.onClose}
            blockScroll={true}
            icons={() => (
                <React.Fragment>
                    <button
                        style={{ position: "absolute", left: "1rem" }}
                        className="p-link"
                    >
                        <img
                            className={styles.idwalLogo}
                            alt={"logo"}
                            src={logo}
                        />
                    </button>
                </React.Fragment>
            )}
        >
            <div className="flex flex-column h-full">
                {sideBarItems.map((item) => {
                    let panel = spinner;
                    if (item.items) {
                        panel = (
                            <PanelMenu
                                model={item.items}
                                className={styles.PanelMenu}
                            />
                        );
                    }
                    return (
                        <>
                            <p className={styles.panelTitle}>{item.title}</p>
                            {panel}
                        </>
                    );
                })}
                {props.customerPortalLink && (
                    <>
                        <p className={styles.panelTitle}>{company_name}</p>
                        <PanelMenu
                            model={idwalMenuItems}
                            className={styles.PanelMenu}
                        />
                    </>
                )}
                <div className="mt-auto">
                    <hr className="mb-3 border-top-1 border-none border-gray-300"></hr>
                    <PanelMenu
                        model={idwalFooterItems}
                        className={styles.PanelMenu}
                    />
                </div>
            </div>
        </Sidebar>
    );
};
